import React from 'react'

const CustomContainer = ({extra_class = "",children}) => {
  const className = "max-w-[90rem] mx-auto px-4 "  + extra_class
  return (
    <div className={className}>
      {children}
    </div>
  )
}

export default CustomContainer